import { consent } from './docs/consent';
import { offer } from './docs/offer';
import { privacy } from './docs/privacy';
import type { LegalDoc, LegalDocId } from './types';

export * from './operator';
export * from './types';
export { parseInline } from './inline';

/** Порядок — как на экране «Документы» и в подвале сайта. */
export const LEGAL_DOCS: readonly LegalDoc[] = [privacy, offer, consent];

export const LEGAL_DOC_IDS: readonly LegalDocId[] = LEGAL_DOCS.map((doc) => doc.id);

export function getLegalDoc(id: string): LegalDoc | undefined {
  return LEGAL_DOCS.find((doc) => doc.id === id);
}
